import moment from 'moment'
import store from '../store'
import { $t, i18next } from '../i18n'
import { callGetData } from './callAxios'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export function returnError () {
  return { type: 'error' }
}

export async function getPortals (filters) {
  const url = '/diffusion_annonceur'
  const response = await getPortalsQuery(HTTP_HYPER_ESPACE_BACKEND, filters, url)

  if (response && response.data && response.data._embedded) {
    return {
      total: response.data.total_items,
      count: response.data.total_items,
      list: response.data._embedded.diffusion_annonceur,
      page_count: response.data.page_count,
      items_per_page: response.data.page_size,
      page: response.data.page,
      results: response.data._embedded.diffusion_annonceur,
      portals: response.data._embedded.diffusion_annonceur,
      type: 'success'
    }
  } else {
    return returnError()
  }
}

export async function getAllPortals (filters, selected) {
  const url = '/v2/diffuseur'
  const response = await getPortalsQuery(HTTP_HYPER_ESPACE_BACKEND, filters, url)
  // console.log(response)

  if (response && response.data) {
    // V2
    return {
      total: response.data.totalItems,
      count: response.data.totalItems,
      list: response.data.items,
      page_count: response.data.totalPages,
      items_per_page: response.data.perPage,
      page: response.data.currentPage,
      results: response.data.items,
      portals: response.data.items,
      type: 'success'
    }
    // V1
    // return {
    //   total: response.data.total_items,
    //   count: response.data.total_items,
    //   list: response.data._embedded.diffuseur,
    //   page_count: response.data.page_count,
    //   items_per_page: response.data.page_size,
    //   page: response.data.page,
    //   results: response.data._embedded.diffuseur,
    //   portals: response.data._embedded.diffuseur,
    //   type: 'success'
    // }
  } else {
    return returnError()
  }
}

export async function getPortalsQuery (http, filters, url) {
  const qs = require('qs')

  const newFilters = getFilters(formatPortalsFilters(filters), url, ['diffuseur-nom', 'diffuseur-gratuit', 'diffusion-active'])
  const params = {
    params: newFilters,
    paramsSerializer: function () {
      return qs.stringify(newFilters, { encode: false })
    }
  }
  return await callGetData(http, url, params)
}

function toCamelCase (str) {
  return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
}

function getFilters (filters, url, paramsToCamelCase = []) {
  const isV2 = url.toLowerCase().includes('/v2')
  if (!isV2) return filters

  const result = { ...filters }

  paramsToCamelCase.forEach(key => {
    if (key in result) {
      result[toCamelCase(key)] = result[key]
      delete result[key]
    }
  })
  console.log(result, 'result')
  return result
}

export async function getUsersPortailsQuotas () {
  const url = '/users-portals-quotas'

  return HTTP_HYPER_ESPACE_BACKEND.get(url)
    .then((response) => {
      return response.data
    })
}

/**
 * * BUG: 111563 les quotas pour l'utilisateur connecté UNIQUEMENT
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function getUserPortailsQuotas () {
  const url = '/user/portals/quotas'

  return HTTP_HYPER_ESPACE_BACKEND.get(url)
    .then((response) => {
      return response.data
    })
}

export async function activerDiffusionAnnonceur (nomDeCodeDiffuseur) {
  const url = '/diffusion_annonceur'
  const user = store.getters.getUser
  try {
    const response = await HTTP_HYPER_ESPACE_BACKEND.post(url, {
      annonceur: user.advertiser,
      diffuseur: nomDeCodeDiffuseur
    })
    return { reponse: response.data }
  } catch (error) {
    return { type: 'error', message: error }
  }
}

export async function desactiverDiffusionAnnonceur (nomDeCodeDiffuseur) {
  const data = {
    active: false
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .patch('/diffusion_annonceur_desactiver/' + nomDeCodeDiffuseur, data)
    .then(() => {
      return {
        reponse: { success: '- ' + $t('portals.list.deactivateDiffusionConfirmation') }
      }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function modificationQuotaAnnonces (nomDeCodeDiffuseur, value) {
  const data = {
    quota: value
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .patch('/modification_quota_annonces/' + nomDeCodeDiffuseur, data)
    .then((response) => {
      return {
        reponse: response.data
      }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function modificationIdentifiants (idDiffusion, identifiants) {
  const data = {
    identifiants: identifiants
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .patch(`/diffusion_annonceur/${idDiffusion}`, data)
    .then((response) => {
      return {
        reponse: response.data
      }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export function tryParseJson (tabJson) {
  try {
    const o = JSON.parse(tabJson)

    if (o && typeof o === 'object') {
      return o
    }
  } catch (e) { }

  return false
}

export async function diffusionAnnonceActivate (tabJson) {
  let tab = tabJson
  if (tryParseJson(tabJson)) {
    tab = tryParseJson(tabJson)
  }

  // First we get the "diffusion annonce" ids by doing the axios calls in parallel.
  const urls = []
  for (const diffusion of tab.diffusions) {
    const annonce = diffusion.annonce
    const diffuseur = diffusion.diffuseur
    urls.push('/diffusion-annonce-diffuseur?annonce=' + annonce + '&diffuseurCode=' + diffuseur)
  }

  const promiseArr = urls.map(url => {
    return HTTP_HYPER_ESPACE_BACKEND.get(url)
      .then(res => {
        const diffusionAnnonce = res.data._embedded.diffusion_annonce[0]
        if (diffusionAnnonce) {
          const diffusion = tab.diffusions.find(
            e => e.annonce === diffusionAnnonce.ad.id && e.diffuseur === diffusionAnnonce.advertiserPublication.portal.code
          )
          diffusion.diffusionAnnonceId = diffusionAnnonce.id
        }
      })
  })

  await Promise.all(promiseArr)

  // Sometimes it is possible that the diffusion_annonce doesn't exist yet, for example when we add a new portal from
  // the gestionnaire without doing a diffusion. In this case, we must create the diffusion_annonce.
  for (const diffusion of tab.diffusions) {
    if (!diffusion.diffusionAnnonceId) {
      await HTTP_HYPER_ESPACE_BACKEND.post('/diffusion-annonce/diffusions', diffusion)
        .then(res => {
          const diffusionAnnonce = res.data
          const diffusion = tab.diffusions.find(
            e => e.annonce === diffusionAnnonce.ad.id && e.diffuseur === diffusionAnnonce.advertiserPublication.portal.code
          )
          diffusion.diffusionAnnonceId = diffusionAnnonce.id
        })
    }
  }

  // Next, we update the status of each "diffusion annonce" by doing the axios calls in parallel again.
  const urlsPatch = []
  for (const diffusion of tab.diffusions) {
    const diffusionAnnonceId = diffusion.diffusionAnnonceId
    const active = diffusion.activate === 1
    urlsPatch.push({
      url: '/diffusion-annonce/activated/' + diffusionAnnonceId,
      data: { active }
    })
  }

  const promiseArrPatch = urlsPatch.map(urlPatch => {
    return HTTP_HYPER_ESPACE_BACKEND.patch(urlPatch.url, urlPatch.data)
  })

  return Promise.all(promiseArrPatch)
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getDiffusionAnnonces (filters) {
  const params = {
    params: filters
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/diffusion-annonce-diffuseur', params)
    .then(posts => {
      return {
        total: posts.data.total_items,
        list: posts.data._embedded.diffusion_annonce
      }
    })
}

export async function getDiffusionAnnonceByAnnonce (annonce) {
  const response = await HTTP_HYPER_ESPACE_BACKEND.get(`/diffusion-annonce/${annonce}`)
  const data = response.data

  if (Array.isArray(data)) {
    return data
  }

  if (data && data._embedded && data._embedded.diffusion_annonce) {
    return data._embedded.diffusion_annonce
  }

  return []
}

/**
 * Désactive toutes les diffusions portails actives pour les annonces données.
 * Un seul appel HTTP vers hyper-espace-api ; la parallélisation est gérée côté backend.
 *
 * @param {number[]} postIds
 * @returns {Promise<{type: string, message?: *}>}
 */
export async function clearPortalSelectionForPosts (postIds) {
  if (!postIds || postIds.length === 0) {
    return { type: 'success' }
  }

  try {
    const response = await HTTP_HYPER_ESPACE_BACKEND.post('/diffusion-annonce/clear-selection', {
      annonceIds: postIds
    })

    if (response.data && response.data.success === false) {
      return { type: 'error', message: response.data.error }
    }

    return { type: 'success' }
  } catch (error) {
    return { type: 'error', message: error }
  }
}

export async function getDiffusionAnnonceByAnnonceForPortal (annonce, idportal) {
  return HTTP_HYPER_ESPACE_BACKEND
    .get('/diffusion-annonce-diffuseur?annonce=' + annonce + '&diffuseur=' + idportal)
    .then(response => {
      return response.data._embedded.diffusion_annonce
    })
}

export async function exportCsvAllPortails (filters, selected, exportWithCallTracking, filename = null) {
  const user = store.getters.getUser
  // export des contacts réservé aux comptes principales et admin
  if (user.roles.includes('ROLE_SUB_USER')) {
    return { type: 'error', message: $t('layouts.exportErrorAccess') }
  }
  const sitimmoUser = store.getters.getSitimmoUser

  // vérification de l'email pour l'envoi de l'export
  const hasEmail = sitimmoUser && sitimmoUser.email

  if (filters.contactManager === true && exportWithCallTracking === true) {
    filters.exportCallTracking = 'O'
  }

  if (filters.beforeContacts != null) {
    const dateBefore = moment(filters.beforeContacts).format('YYYY-MM-DD')
    filters.dateMin = dateBefore
  } else {
    const dateBefore = moment().subtract(7, 'days')
    const before = moment(dateBefore).format('YYYY-MM-DD')
    filters.dateMin = before
  }

  if (filters.afterContacts != null) {
    let dateAfter = moment(filters.afterContacts).add(1, 'days')
    dateAfter = moment(dateAfter).format('YYYY-MM-DD')
    filters.dateMax = dateAfter
  }

  // export type
  let exportType = ''
  if (filters.contactManager === true && exportWithCallTracking === true) {
    exportType = 'diffuseur_mailtracking_calltracking'
  } else if (filters.contactManager === true) {
    exportType = 'diffuseur_mailtracking'
  } else {
    exportType = 'diffuseur'
  }

  const requestFilters = Object.assign({}, formatPortalsFilters(filters))

  // request
  const data = { filters: requestFilters, exportType: exportType, to: hasEmail ? sitimmoUser.email : '', filename: filename, lang: i18next.language }

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/export_requests', data)
    .then(response => {
      if (response.status === 202) {
        // Si pas d'email, retourner un message d'avertissement
        if (!hasEmail) {
          return { type: 'warning', message: $t('layouts.exportWarningNoEmail') }
        }
        return { type: 'success', message: $t('layouts.exportSuccess') }
      }
      return { type: 'error', message: $t('error.found') }
    })
    .catch(error => {
      return { type: 'error', message: $t('error.found') }
    })
}

export async function exportCsvPortails (filters, selected, filename = null) {
  const sitimmoUser = store.getters.getSitimmoUser

  // vérification de l'email pour l'envoi de l'export
  const hasEmail = sitimmoUser && sitimmoUser.email

  if (selected != null) {
    filters['diffuseur-codeNames'] = selected
  }

  // export type
  let exportType = ''
  if (filters && filters.contactManager === true) {
    exportType = 'diffusion_annonceur_mailtracking'
  } else {
    exportType = 'diffusion_annonceur'
  }

  const requestFilters = Object.assign({}, formatPortalsFilters(filters))

  // request
  const data = { filters: requestFilters, exportType: exportType, to: hasEmail ? sitimmoUser.email : '', filename: filename, lang: i18next.language }

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/export_requests', data)
    .then(response => {
      if (response.status === 202) {
        // Si pas d'email, retourner un message d'avertissement
        if (!hasEmail) {
          return { type: 'warning', message: $t('layouts.exportWarningNoEmail') }
        }
        return { type: 'success', message: $t('layouts.exportSuccess') }
      }
      return { type: 'error', message: $t('error.found') }
    })
    .catch(error => {
      return { type: 'error', message: $t('error.found') }
    })
}

/**
 * Retourne un portail selon son identifiant.
 *
 * @param {string} portalId
 * @returns {object}
 */
export async function getPortalById (portalId) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      // const url = '/diffuseur/' + portalId
      const url = '/v2/diffuseur/' + portalId

      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * Retourne une DiffusionAnnonceur par son id.
 *
 * @param {string} id
 * @returns {object}
 */
export async function getDiffusionAnnonceurById (id) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      let url = '/diffusion_annonceur/' + id

      if (i18next.language != null) {
        url = url + '?lang=' + i18next.language
      }

      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * @param filters
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function diffusionsAnnonces (filters) {
  const params = {
    params: filters
  }
  return HTTP_HYPER_ESPACE_BACKEND.get('/diffusions-annonces', params)
    .then(response => {
      return response.data
    })
}

/**
 * Retourne une DiffusionAnnonceur par le nom de code du diffuseur.
 *
 * @returns {object}
 * @param codeName
 */
export async function getDiffusionAnnonceurByCodeName (codeName) {
  let url = '/diffusion_annonceur?' + 'diffuseur-codeNames=' + codeName

  if (i18next.language != null) {
    url += '&lang=' + i18next.language
  }

  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return { infos: response.data }
  })
}

export async function getDiffuseurInfos (diffuseurId) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      // const url = '/diffuseur/'
      const url = '/v2/diffuseur/'
      const endpointUrl = url + diffuseurId

      HTTP_HYPER_ESPACE_BACKEND.get(endpointUrl).then((response) => {
        return resolve({
          reponse: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function chargerCategories (metier) {
  const params = {
    params: {
      lang: i18next.language,
      metiers: metier
    }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/v2/categories', params)
    .then(response => {
      store.commit('donnees/SET_CATEGORY_PORTALS', response.data.categories)
      return response.data.categories
    })
}

export async function getQuotasForUser (user) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const endpointUrl = '/quotas?user=' + user

      HTTP_HYPER_ESPACE_BACKEND.get(endpointUrl).then((response) => {
        return resolve({ reponse: response.data })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function updateQuotas (listQuotas) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const params = []
      for (const quota of Object.entries(listQuotas)) {
        params.push(quota[1])
      }
      const endpointUrl = '/updateQuotas'
      HTTP_HYPER_ESPACE_BACKEND.post(endpointUrl, { params }).then((response) => {
        return resolve({ reponse: response.data })
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getUserQuotaPerPortal (idUser, idPortail) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const endpointUrl = '/userQuotaPerPortal/' + idUser + '/' + idPortail

      HTTP_HYPER_ESPACE_BACKEND.get(endpointUrl).then((response) => {
        return resolve({ reponse: response.data.quota })
      })
    }, Math.random() * 1000 + 250)
  })
}

export function formatPortalsFilters (filters) {
  const user = store.getters.getUser
  const params = []

  params['annonceur-id'] = user.advertiser
  params.annonceur = user.advertiser
  params.idAnnonceur = user.advertiser

  if (filters.offsetPortals != null) {
    params.offset = filters.offsetPortals
  }

  if (!filters.search) {
    params['diffuseur-nom'] = ''
  } else {
    params['diffuseur-nom'] = filters.search
  }

  // if (filters.contactManager === true) {
  //   params.contactManager = true
  // }

  if (i18next.language) {
    params.lang = i18next.language
  }

  if (filters.privatePortal) {
    params.private = filters.privatePortal
  } else {
    params.private = 'N'
  }

  params.multidiffusionCompatible = 'N'

  if (filters.gratuit === 'O' || filters.gratuit === 'N') {
    params['diffuseur-gratuit'] = filters.gratuit
  }

  if (filters.active != null) {
    params['diffusion-active'] = filters.active
  }

  if (filters.quota != null) {
    params.quota = filters.quota
  }

  if (filters.category != null) {
    params.categorie = filters.category
  }

  if (filters.before != null) {
    const dateBefore = moment(filters.before).format('YYYY-MM-DD')
    params.activebefore = dateBefore
  }

  if (filters.after != null) {
    const dateAfter = moment(filters.after).format('YYYY-MM-DD')
    params.activeafter = dateAfter
  }

  if (filters.beforeContacts != null) {
    const dateBefore = moment(filters.beforeContacts).format('YYYY-MM-DD')
    params['date-min-contact-mailtracking'] = dateBefore
    params.dateMin = dateBefore
  } else {
    if (filters.contactManager === true) {
      const dateBefore = moment().subtract(7, 'days')
      const before = moment(dateBefore).format('YYYY-MM-DD')
      params['date-min-contact-mailtracking'] = before
      params.dateMin = before
    }
  }

  if (filters.afterContacts != null) {
    const dateAfter = moment(filters.afterContacts).format('YYYY-MM-DD')
    params['date-max-contact-mailtracking'] = dateAfter
    params.dateMax = dateAfter
  }

  if (filters.postId != null) {
    params.annonce = filters.postId
  }

  if (filters.portalsSelected != null) {
    if (filters.portalsSelected === true) {
      params['portail-selectionne'] = 'O'
    } else {
      params['portail-selectionne'] = 'N'
    }
  }

  if (filters.page != null) {
    params.page = filters.page
  }

  if (filters.limit != null) {
    params.perPage = filters.limit
  }

  if (filters.fields != null) {
    params.fields = filters.fields
  }

  if (filters.diffuseurCodeNames != null) {
    params['diffuseur-codeNames'] = filters.diffuseurCodeNames
  }

  if (filters.codeNames != null && filters.codeNames !== '') {
    params.codeNames = filters.codeNames
  }

  /* Gestion des portails à ne pas afficher */
  if (!filters.excludedCodeNames) {
    filters.excludedCodeNames = ''
  }
  // Gestion diffuseurs
  const excludedCodes = getExcludedCodeNames()
  if (excludedCodes && (filters.category !== 'réseaux sociaux')) {
    for (let cpt = 0; cpt < excludedCodes.length; cpt++) {
      if (!filters.excludedCodeNames.includes(excludedCodes[cpt])) {
        filters.excludedCodeNames = filters.excludedCodeNames + ',' + excludedCodes[cpt]
      }
    }
  }
  // Gestion clap
  if (!filters.excludedCodeNames.includes('CLAP_VIDEO')) {
    filters.excludedCodeNames = filters.excludedCodeNames + ',CLAP_VIDEO_VO,CLAP_VIDEO_IMMO'
  }

  params.excludedCodeNames = filters.excludedCodeNames

  if (filters.stock != null) {
    params['annonceur-stocks'] = filters.stock
  }

  if (filters.sanscontacts === 'O') {
    params.sansContacts = filters.sanscontacts
  }

  // Filtre négociateur pour Contact Manager
  if (filters.negociateur_code != null && filters.negociateur_code !== '') {
    params.negociateur_code = filters.negociateur_code
  }

  // if (filters.withContacts === true) {
  //   params.withContacts = filters.withContacts
  // }
  switch (filters.sort) {
    case 'nom':
      params.orderBy = 'diffuseur-name'
      break
    case 'date':
      params.orderBy = '-date-dernier-envoi'
      break
    case 'annonces':
      params.orderBy = '-nb-annonces'
      break
    case 'contact':
      params.orderBy = 'nb-contacts'
      break
    case 'nb-contacts':
      params.orderBy = 'nb-contacts'
      break
    case 'contactTel':
      params.orderBy = 'contactTel'
      break
    default:
      params.orderBy = 'diffuseur-name'
  }

  return params
}

function getExcludedCodeNames () {
  return [
    'CLAP_VIDEO_VO',
    'CLAP_VIDEO_IMMO',
    'FACEBOOK_POST_IMMO',
    'FACEBOOK_POST_VIDEO_IMMO',
    'FACEBOOK_POST_VIDEO_VO',
    'FACEBOOK_POST_VO',
    'FACEBOOK_POST_IMMO_BIENS_VENDUS',
    'FACEBOOK_EDITO',
    'GOOGLE_MY_BUSINESS_IMMO',
    'GOOGLE_MY_BUSINESS_VO',
    'GOOGLE_MY_BUSINESS_IMMO_BIENS_VENDUS',
    'GOOGLE_MY_BUSINESS_EDITO',
    'INSTAGRAM_IMMO',
    'INSTAGRAM_VIDEO_IMMO',
    'INSTAGRAM_VIDEO_VO',
    'INSTAGRAM_VO',
    'INSTAGRAM_IMMO_BIENS_VENDUS',
    'INSTAGRAM_EDITO',
    'LINKEDIN_IMMO',
    'LINKEDIN_VIDEO_IMMO',
    'LINKEDIN_VO',
    'LINKEDIN_VIDEO_VO',
    'LINKEDIN_IMMO_BIENS_VENDUS',
    'LINKEDIN_EDITO'
  ]
}
